import React, { useState } from "react";
import { FullScreenDialog } from "./FullScreenDialog";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { DateTime } from "luxon";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { formatFullDate } from "./date-formatting";

/**
 * @param {object} props
 * @param {(newDate: number) => void} props.onSave
 * @param {string} props.title
 * @param {boolean} props.isBusy
 * @param {import("react").ReactNode} props.children
 * @param {number} props.initialValue
 * @param {boolean} [props.disablePast]
 * @param {boolean} [props.disableFuture]
 * @param {string} [props.timezone]
 * @param {"date" | "datetime"} [props.mode]
 * @param {(date: number) => string} [props.formatter]
 */
export const EditDateDialog = ({
  onSave,
  title,
  isBusy,
  children,
  initialValue = 0,
  disableFuture = false,
  disablePast = false,
  timezone = undefined,
  mode = "date",
  formatter = (date) => formatFullDate(date),
}) => {
  // the one we use for the date controls
  const [date, setDate] = useState(DateTime.fromMillis(initialValue, { zone: timezone }));
  // the one we send to the server
  const [newDate, setNewDate] = useState(initialValue);

  const onSaveHandler = () => {
    onSave(newDate);
  };

  /**
   * @param {DateTime} componentDate
   */
  const onUpdateDate = (componentDate) => {
    setNewDate(componentDate.toMillis());
    setDate(componentDate);
  };

  return (
    <FullScreenDialog
      title={`Edit ${title.toLowerCase()}`}
      actionText="SAVE"
      onSaveHandler={onSaveHandler}
      isBusy={isBusy}
      CustomControl={children}
    >
      <Card>
        <Box p={2}>
          <Stack direction="row">
            {mode === "date" && (
              <DatePicker
                defaultValue={date}
                label="Date"
                onChange={onUpdateDate}
                disablePast={disablePast}
                disableFuture={disableFuture}
              />
            )}
            {mode === "datetime" && (
              <DateTimePicker
                defaultValue={date}
                label="Date"
                onChange={onUpdateDate}
                disablePast={disablePast}
                disableFuture={disableFuture}
              />
            )}
            <Box justifyContent="center" alignItems="center" display="flex" flex={1}>
              <Typography>{formatter(newDate)}</Typography>
            </Box>
          </Stack>
        </Box>
      </Card>
    </FullScreenDialog>
  );
};
